import Dbm from "dbm";

export default class KeyboardInput extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        this.item.requireProperty("screen", null);

        this._callback_keyDownBound = this._callback_keyDown.bind(this);

        this.item.requireProperty("active", false).addUpdate(this._getScopedCallFunctionCommand(this._activeChanged));
    }

    _activeChanged() {
        if(this.item.active) {
            this._activate();
        }
        else {
            this._deactivate();
        }
    }

    _activate() {
       //console.log("_activate");

        window.addEventListener("keydown", this._callback_keyDownBound);
    }

    _deactivate() {
        //console.log("_deactivate");

        window.removeEventListener("keydown", this._callback_keyDownBound);
    }

    _callback_keyDown(aEvent) {
        //console.log("_callback_keyDown");

        if (aEvent.code === "Space") {
            if(this.item.screen.controller.leftInput) {
                this.item.screen.controller.leftInput();
            }
            

            aEvent.stopImmediatePropagation();
            aEvent.preventDefault();
            
        }

        if (aEvent.code === "ShiftLeft" || aEvent.code === "ShiftRight" || aEvent.code === "Enter") {
            if(this.item.screen.controller.rightInput) {
                this.item.screen.controller.rightInput();
            }

            aEvent.stopImmediatePropagation();
            aEvent.preventDefault();
        }
    }
}